import { createRoute, redirect } from '@tanstack/react-router';
import { platformLayoutRoute } from './platformLayout.js';

/**
 * /platform — landing. Redirects to the tenant list (the only read surface in
 * Phase B). A real summary dashboard lands in Phase F.
 */
export const platformIndexRoute = createRoute({
  getParentRoute: () => platformLayoutRoute,
  path: '/platform',
  beforeLoad: () => {
    throw redirect({ to: '/platform/tenants' });
  },
  component: () => null,
});
